export const injectable: ClassDecorator = (Target: any) => {
  const autoInject: [] = Target.prototype.$autoInject || [];

  class Injectable extends Target {
    constructor(...args) {
      const parent = args.slice(0, -autoInject.length);
      const autoInjectProps = args.slice(parent.length);
      super(...parent);
      autoInject.forEach((prop, i) => {
        this[prop] = autoInjectProps[i];
      });
    }
  }

  Injectable.$inject = (Injectable.$inject || []).concat(autoInject);
  return Injectable as any;
};

export const inject: PropertyDecorator = (
  protoype: any,
  propertyKey: string,
) => {
  protoype.$autoInject = protoype.$autoInject || [];
  protoype.$autoInject.push(propertyKey);
};
